import { render } from "./DemandTemplateDetailsPage.vue?vue&type=template&id=7c74f09a"
import script from "./DemandTemplateDetailsPage.vue?vue&type=script&lang=ts"
export * from "./DemandTemplateDetailsPage.vue?vue&type=script&lang=ts"
script.render = render

export default script